import {Component, Inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService,} from '../../_services/index';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
    standalone: false,
  selector: 'createPoamTemplate-component',
  templateUrl: 'createPoamTemplate.component.html'
})

export class CreatePoamTemplateComponent {
  categories: string[] = [];
  formGroup: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<CreatePoamTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public route: ActivatedRoute,
    public formBuilder: FormBuilder,
    public alertService: AlertService,
    public authenticationService: AuthenticationService) {
    this.formGroup = formBuilder.group({
      category: ['', Validators.required],
      name: ['', Validators.required],
      isGlobal: [false],
    });
    this.categories = data.categories;
  }

  onClose(isCancel: boolean): void {
    this.dialogRef.close(isCancel ? this.formGroup.value : null);
  }
}
